export default "__VITE_ASSET__C5U62KrM__"